var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3049.22 1270.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #2267ce;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m0,0v399.61h649.37l2.54,867.09,546.25-866.02.67-1.07c280.29,1.87,516.57-2.66,643.65-2.66V0H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1368.92,866.6h977.66c142.02,0,205.56-80.35,205.56-231.72s-63.54-231.72-205.56-231.72l-504.09-6.21L2098.57,0h343.52c309.66,10.65,607.14,197.79,607.14,634.88s-315.81,635.37-635.37,635.37h-1299.73l254.79-403.64Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0341ac4d949091fb20a54057d1552daa.svg";
export { ForwardRef as ReactComponent };